// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_layout.scss
// module id = 42
// module chunks = 0